import React, { useRef } from "react";
import { useRemoteComponents } from "./internal/provider.js";
export function createHelpPanelLoader({ Fallback }) {
    return function HelpPanelLoader(props) {
        const ref = useRef(null);
        const components = useRemoteComponents(ref, { HelpPanel: Fallback });
        return components.HelpPanel ? React.createElement(components.HelpPanel, { ...props }) : React.createElement("div", { ref: ref });
    };
}
